"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeButtonStyling = function (disabled, theme, textOverflowHandling, invertColors) {
    var _a;
    return (0, react_1.css)((_a = {
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: theme.mvf.palette.text.continueButtonTextColor,
            fontWeight: theme.mvf.typography.weight.thick,
            fontSize: "".concat(theme.mvf.fontSize.medium, "px"),
            fontFamily: theme.typography.fontFamily,
            letterSpacing: 0
        },
        _a[theme.breakpoints.up('mobileMedium')] = {
            fontSize: "".concat(theme.mvf.fontSize.hefty, "px"),
        },
        _a[theme.breakpoints.up('tabletSmall')] = {
            fontSize: "".concat(theme.mvf.fontSize.swoll, "px"),
        },
        _a[theme.breakpoints.up('desktopLarge')] = {
            fontSize: "".concat(theme.mvf.fontSize.large, "px"),
        },
        _a.minHeight = '100%',
        _a.height = textOverflowHandling === 'newline' ? 'auto' : '100%',
        _a.lineHeight = theme.mvf.lineHeight.small,
        _a.textTransform = 'none',
        _a['&.MuiButton-root'] = {
            borderRadius: '6px',
            backgroundColor: disabled
                ? (0, material_1.lighten)(theme.mvf.palette.status.disabled, theme.mvf.filters.lighten.strong)
                : theme.mvf.palette.component.continueButtonColor,
            color: disabled
                ? theme.mvf.palette.status.disabled
                : theme.mvf.palette.text.continueButtonTextColor,
            boxShadow: theme.mvf.boxShadow.navigation.primary,
            '@media (hover: hover)': {
                '&:hover': {
                    backgroundColor: theme.mvf.palette.component.continueButtonHoverColor,
                    boxShadow: theme.mvf.boxShadow.navigation.secondary,
                },
            },
            '.MuiButton-endIcon': {
                position: 'absolute',
                right: theme.mvf.spacing.small,
            },
        },
        _a[invertColors ? '&.MuiButton-root' : ''] = {
            boxShadow: theme.mvf.boxShadow.navigation.primary,
            border: 'solid',
            borderWidth: theme.mvf.border.width.medium,
            borderColor: theme.mvf.palette.component.continueButtonColor,
            color: theme.mvf.palette.component.continueButtonColor,
            backgroundColor: theme.mvf.palette.text.continueButtonTextColor,
            '.MuiButton-endIcon': {
                position: 'absolute',
                right: theme.mvf.spacing.small,
            },
        },
        _a[disabled ? '&.MuiButton-root' : ''] = {
            boxShadow: theme.mvf.boxShadow.navigation.primary,
            color: theme.mvf.palette.status.disabled,
            '.MuiButton-endIcon': {
                position: 'absolute',
                right: theme.mvf.spacing.small,
            },
        },
        _a));
};
exports.default = makeButtonStyling;
//# sourceMappingURL=makeButtonStyling.js.map